var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-page"}},[_c('HomeHero'),_c('HomeCardGrid'),_c('Countdown',{staticClass:"countdown",attrs:{"extdate":"2023-05-08T23:59:59Z"}}),_c('Partners'),_c('AboutEESTEC')],1)}
var staticRenderFns = []

export { render, staticRenderFns }